<template>
    <div class="contain">
        <ManageHeaderMenu></ManageHeaderMenu>
        <div class="main">
            <ManageMenu defaultActive="2-2"></ManageMenu>
            <div class="content">
                <div class="content-title">
                    <span>{{ pageName }}：数量 {{ pagination.total }}</span>
                    <el-button style="margin-left: auto;" class="content-title-button" @click="refresh">刷新数据</el-button>
                    <el-button class="content-title-button" @click="drawer = true">添加数据</el-button>
                </div>
                <div style="padding: 20px;">
                    <el-table :data="tableData" border class="custom-table">
                        <el-table-column prop="name" label="QQ 群名称" width="300">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top">
                                    <p style="margin-bottom: 5px;">备注信息：</p>
                                    <div slot="reference" class="name-wrapper" style="display: flex; align-items: center;">
                                        <img class="table-column-image"
                                            :src="`http://p.qlogo.cn/gh/${scope.row.qq}/${scope.row.qq}/100/`" alt="">
                                        <span style="margin-left: 10px;">{{ scope.row.name }}</span>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="qq" label="QQ 群号">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top">
                                    <p style="display: flex; align-items: center;">
                                        <span>QQ 群信息：{{ scope.row.name }}</span>
                                        <el-link style="margin-left: 10px;" target="_blank" :href="scope.row.link" type="info">访问链接</el-link>
                                    </p>
                                    <div slot="reference" class="name-wrapper" style="display: flex; align-items: center;">
                                        <i class="el-icon-price-tag"></i>
                                        <span style="margin-left: 10px; font-family: Courier; font-weight: bolder;">{{ scope.row.qq }}</span>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="owner" label="群主 QQ">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top">
                                    <p style="display: flex; align-items: center;">
                                        <span>QQ 群信息：{{ scope.row.name }}</span>
                                        <el-link style="margin-left: 10px;" target="_blank" :href="scope.row.link" type="info">访问链接</el-link>
                                    </p>
                                    <div slot="reference" class="name-wrapper" style="display: flex; align-items: center;">
                                        <img class="table-column-image"
                                        :src="`https://q1.qlogo.cn/g?b=qq&nk=${scope.row.owner}&s=640`" alt="">
                                        <span style="margin-left: 10px; font-family: Courier; font-weight: bolder;">{{ scope.row.owner }}</span>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" label="群成员数量">
                            <template slot-scope="scope">
                                <i style="margin-right: 10px" class="el-icon-user-solid"></i>
                                <span style="font-family: Courier; font-weight: bolder;">{{ scope.row.number }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="link" label="链接地址" align="center">
                            <template slot-scope="scope">
                                <el-link target="_blank" :href="scope.row.link" type="info">访问链接</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button class="table-button" size="mini" @click="updateData(scope.row)">编辑</el-button>
                                <el-popconfirm confirm-button-text='确定' cancel-button-text='取消'
                                    confirm-button-type="primary" cancel-button-type="info" title="温馨提示：是否确定删除当前数据"
                                    @confirm="deleteData(scope.row)">
                                    <el-button plain type="danger" class="table-button" size="mini"
                                        slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div
                        style="background-color: #ffffff; height: 50px; display: flex; align-items: center; margin-top: 20px;">
                        <el-pagination @current-change="changePage" background layout="prev, pager, next"
                            :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-drawer :title="`${pageName} ${form.id == '' ? '添加数据' : '更新数据'}`" style="z-index: 1;" :visible.sync="drawer"
            direction="ltr" :before-close="handleClose">
            <div class="custom-form">
                <el-form :model="form">
                    <el-form-item label="QQ 群名称">
                        <el-input v-model="form.name" placeholder="群名称" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ 群号">
                        <el-input v-model="form.qq" placeholder="QQ 群号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="群主 QQ">
                        <el-input v-model="form.owner" placeholder="群主 QQ" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="群成员数量">
                        <el-input type="number" v-model="form.number" placeholder="群成员数量" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="链接地址">
                        <el-input v-model="form.link" placeholder="链接地址" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button @click="drawer = false">取消操作</el-button>
                    <el-button type="primary" @click="submit">确定设置</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import ManageHeaderMenu from './ManageHeaderMenu.vue';
import ManageMenu from './ManageMenu.vue';
import Api from "@/apis"

export default {
    data() {
        return {
            pageName: "QQ 群资源",
            tableData: [],
            drawer: false,
            pagination: {
                page: 1,
                page_size: 10,
                total: 0,
            },
            form: {
                id: '',
                name: '',
                qq: '',
                owner: '',
                number: '',
                link: '',
            }
        }
    },
    beforeCreate() {

    },
    methods: {
        handleClose(done) {
            this.clearForm()
            done()
        },
        filterBlank() {
            Object.keys(this.form).forEach(key => {
                if (typeof this.form[key] === 'string') {
                    this.form[key] = this.form[key].trim();
                }
            });
        },
        refresh() {
            this.selectTableData()
        },
        changePage(page) {
            this.pagination.page = page
            this.selectTableData()
        },
        isFilledForm() {
            for (let key in this.form) {
                if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                    if (this.form[key] === '' && key !== 'id') {
                        return true
                    }
                }
            }
            return false;
        },
        clearForm() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = '';
            });
        },
        submit() {
            if (this.isFilledForm()) {
                this.$message({ message: "填写数据存在空缺", type: 'warning' });
                return
            } else {
                this.filterBlank()
            }
            if (this.form.id) {
                Api.updateGroup(this.form).then(res => {
                    if (res.data.code == 200) {
                        this.selectTableData()
                        this.drawer = false
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this)
                })
            } else {
                Api.insertGroup(this.form).then(res => {
                    if (res.data.code == 200) {
                        this.selectTableData()
                        this.drawer = false
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this)
                })
            }
        },
        deleteData(data) {
            Api.deleteGroup({
                id: data.id
            }).then(res => {
                if (res.data.code == 200) {
                    this.selectTableData()
                    this.$message({ message: res.data.message, type: 'success' });
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this)
            })
        },
        updateData(data) {
            this.drawer = true
            this.form = Object.assign({}, data);
        },
        selectTableData() {
            Api.selectGroup({
                page: this.pagination.page,
                page_size: this.pagination.page_size
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message({ message: res.data.message, type: 'success' });
                    this.tableData = res.data.data.table_data
                    this.pagination.total = res.data.data.total
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this)
            })
        }
    },
    mounted() {
        this.selectTableData()
    },
    components: {
        ManageHeaderMenu,
        ManageMenu
    }
}
</script>
<style scoped>
.main {
    justify-content: space-between;
    display: flex;
}

.content {
    flex: 1;
    overflow-y: scroll;
    height: calc(100vh - 60px);
}

.content-title {
    height: 60px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;
    display: flex;
}

.content-title span {
    font-size: 20px;
}

.custom-form {
    padding: 20px;
}

.table-button {
    margin: 0 5px;
    padding: 5px 10px;
}

.table-column-image {
    width: 25px;
    height: 25px;
    border-radius: 25px;
    display: block;
}
</style>